// Load your vendor libraries. When you do so, make sure you
// Change the 'vendor' entry in `gulp/webpack/webpack.entry.js`
// Remove CommonChunksPlugin in `gulp/webpack/webpack.prod.js` if you don't have any vendor files
import 'isomorphic-fetch'
import 'jquery'
import 'slick-carousel'
let $ = require('jquery')

// Your JavaScript goes here

$(document).ready(function () {
  let menuTrigger = document.querySelectorAll('.pl-js-toggle-nav')
  let canvasOverlay = document.querySelector('#site-canvas-overlay')
  let siteWrapper = document.querySelector('#site-wrapper')

  for (let i = 0; i < menuTrigger.length; i += 1) {
    menuTrigger[i].addEventListener('click', toggleNav)
  }
  canvasOverlay.addEventListener('click', toggleNav)

  function toggleNav () {
    siteWrapper.classList.toggle('show-nav')
  }

  $('.gallery-fade').slick({
    dots: false,
    infinite: true,
    speed: 300,
    fade: true,
    cssEase: 'linear'
  })

  $('.tabs-menu a').click(function (event) {
    event.preventDefault()
    $(this).addClass('is-active')
    $(this).siblings().removeClass('is-active')
    let tab = $(this).attr('href')
    $('.tab-content').not(tab).css('display', 'none')
    $(tab).fadeIn()
    $('.gallery-fade').slick('setPosition')
  })
})

// Enables HMR for development purposes. Degrades gracefully to nothing in production
// Must be located directly at the end of this file. Cannot be abstracted into another
// file, or it won't work.
if (process.env.NODE_ENV === 'development') {
  if (module.hot) module.hot.accept()

  // Silence HMR rubbish logs
  ;(function (global) {
    var consoleLog = global.console.log
    global.console.log = function () {
      if (!(
            arguments.length === 1 &&
            typeof arguments[0] === 'string' &&
            arguments[0].match(/^\[(HMR|WDS)\]/)
          )) {
        consoleLog.apply(global.console, arguments)
      }
    }
  })(window)
}



// WEBPACK FOOTER //
// ./src/js/main.js